export const runtimeConfig =
    typeof window !== 'undefined'
        ? {
              // client
              REACT_APP_SHOWROOM_API_URL: window.variables_env.REACT_APP_SHOWROOM_API_URL,
              REACT_APP_ASSETS_PATH: window.variables_env.REACT_APP_ASSETS_PATH,
              REACT_APP_VEHICLE_API_URL: window.variables_env.REACT_APP_VEHICLE_API_URL,
          }
        : {
              // server
              REACT_APP_SHOWROOM_API_URL: process.env.REACT_APP_SHOWROOM_API_URL,
              REACT_APP_ASSETS_PATH: process.env.REACT_APP_ASSETS_PATH,
              REACT_APP_VEHICLE_API_URL: process.env.REACT_APP_VEHICLE_API_URL,
          }
